import { getDialogConfig } from 'src/app/util/dialog-util';
import { TranslocoService } from '@jsverse/transloco';
import { SimpleAlertDialogComponent, SimpleDialogData } from './../../../dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { BaseDataApiService } from 'src/app/data-transfer/services/base-data-api-service';
import { Router } from '@angular/router';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { AuthService } from './../../../../services/auth-service';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatMenu } from '@angular/material/menu';
import { PackagingExcelUploadDialogComponent } from 'src/app/components/dialogs/packaging-excel-upload-dialog/packaging-excel-upload-dialog.component';
import { PackagingSystemText } from 'src/app/model/path-building-blocks';
import { LicenseService } from 'src/app/services/licensing-service';

@Component({
  selector: 'app-data-menu',
  templateUrl: './data-menu.component.html',
  styleUrls: ['./data-menu.component.scss'],
})
export class DataMenuComponent implements OnDestroy {
  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;

  isAdmin: boolean;
  isValidator: boolean;
  isGs1DataTransferUser: boolean;

  private synchronizeDbSubscription?: Subscription;

  constructor(
    private authService: AuthService,
    private router: Router,
    private baseDataApiService: BaseDataApiService,
    private translateService: TranslocoService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private licenseService: LicenseService
  ) {
    this.isAdmin = this.authService.isUserAdmin();
    this.isValidator = this.authService.isUserValidator();
    this.isGs1DataTransferUser = this.authService.isGs1DataTransferUser();
  }

  clickDirectoryTree() {
    this.router.navigate([PathResolveService.getDirectoryManagementPath(true, PackagingSystemText, [])]);
  }

  clickPackagingImport() {
    const path = PathResolveService.getPackagingImportPath(true, true);
    this.router.navigate([path]);
  }

  clickDataExchangeRequests() {
    const path = PathResolveService.getDataExchangeRequestsPath(true);
    this.router.navigate([path]);
  }

  clickUsers() {
    this.router.navigate([PathResolveService.getUserManagementPath(true)]);
  }

  clickSync() {
    this.spinner.show();
    this.synchronizeDbSubscription = this.baseDataApiService.synchronizeDatabase().subscribe(response => {
      this.spinner.hide();
      this.showSyncResultDialog(response.status);
    });
  }

  clickVersions() {
    const path = PathResolveService.getDependencyVersionsPath(true);
    this.router.navigate([path]);
  }

  clickUiChangelog() {
    const path = PathResolveService.getUiChangelogPath(true);
    this.router.navigate([path]);
  }

  clickExportProfiles() {
    const path = PathResolveService.getExportProfilesPath(true);
    this.router.navigate([path]);
  }

  clickExportList() {
    const path = PathResolveService.getExportListPath(true);
    this.router.navigate([path]);
  }

  clickGs1DataTransfer() {
    const path = PathResolveService.getGS1DataTransferPath(true);
    this.router.navigate([path]);
  }

  clickManageOrganizations() {
    const path = PathResolveService.getOrganizationsManagementPath(true);
    this.router.navigate([path]);
  }

  clickImportLcaExcelData() {
    const path = PathResolveService.getLcaDataExcelImportPath(true);
    this.router.navigate([path]);
  }

  clickTags() {
    const path = PathResolveService.getTagsManagementPath(true);
    this.router.navigate([path]);
  }

  get isPPWRAllowed(): boolean {
    return this.licenseService.isPPWRAllowed;
  }

  clickProfiles() {
    const path = PathResolveService.getProfilesPath(true);
    this.router.navigate([path]);
  }

  clickInternationalInfos() {
    const path = PathResolveService.getInternationalInfosPath(true);
    this.router.navigate([path]);
  }

  private showSyncResultDialog(status: number) {
    let data: SimpleDialogData;
    if (status === 200) {
      data = {
        title: this.translateService.translate('common.text.success'),
        messages: [this.translateService.translate('dataManagement.synchronizeDb.successMessage')],
        icon: 'sync',
      };
    } else {
      data = {
        title: this.translateService.translate('common.text.error'),
        messages: [this.translateService.translate('dataManagement.synchronizeDb.errorMessage')],
        icon: 'error',
      };
    }
    const alertDialogConfig = getDialogConfig(data, '250px');
    this.dialog.open(SimpleAlertDialogComponent, alertDialogConfig);
  }

  clickValidatorSystems() {
    const path = PathResolveService.getValidatorViewSystems(true);
    this.router.navigate([path]);
  }

  clickValidatorUnits() {
    const path = PathResolveService.getValidatorViewUnits(true);
    this.router.navigate([path]);
  }

  clickExcelUpload() {
    this.dialog.open(PackagingExcelUploadDialogComponent, {
      disableClose: true,
    });
  }

  ngOnDestroy(): void {
    this.synchronizeDbSubscription?.unsubscribe();
  }
}
